import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import linkedIn from "../assets/linkedIn.png";

export default function AboutShy() {
    return (
        <div className="font-sans text-gray-800 bg-[#FAFCFF] flex flex-col min-h-screen">
            <Navbar />

            <main className="flex-grow w-full py-8 flex items-center justify-center">
                <div className="max-w-[1280px] w-full mx-auto px-4 md:px-8">
                    
                    <div className="mb-6">
                        <h1 className="text-3xl md:text-4xl font-bold text-[#005AAC] mb-3 tracking-tight">
                            About Shy
                        </h1>
                        <div className="w-16 h-1 bg-gradient-to-r from-[#5B21B6] to-[#D4AF37] rounded-full"></div>
                    </div>

                    <div className="bg-white rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 overflow-hidden max-w-6xl flex flex-col md:flex-row">
                        
                        <div className="flex items-center justify-center p-6 md:w-[40%] lg:w-[35%] h-auto relative">
                            <img 
                                src={linkedIn}
                                alt="Shyaml Punekar - Founder & CEO" 
                                className="w-full h-auto max-w-[400px] object-contain rounded-2xl shadow-lg border border-gray-200"
                            />
                            <div className="absolute bottom-0 left-0 w-full h-2 bg-[#D4AF37]"></div>
                        </div>

                        <div className="p-6 md:p-8 lg:p-10 md:w-[60%] lg:w-[65%] flex flex-col justify-center">
                            
                            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1">
                                Shyaml Punekar
                            </h2>
                            <p className="text-[#5B21B6] font-semibold tracking-wider uppercase text-xs md:text-sm mb-6">
                                Founder & CEO, WamGlammz
                            </p>

                            <div className="space-y-4 text-sm md:text-[15px] text-gray-600 leading-relaxed">
                                <p>
                                    <strong>Shy (Shyaml Punekar)</strong> is the Founder & CEO of WamGlammz, a tech-powered lifestyle and beauty platform designed to elevate confidence, purpose, and representation. 
                                </p>
                                
                                <p>
                                    A Beauty Pageant Winner, Java Backend Developer, makeup artist, model, and entrepreneur, Shy brings a rare blend of creativity and technical expertise to every project she leads. Raised in Mumbai, India and holding a degree in Electronics & Telecommunication Engineering, Shy has built a career that bridges innovation with real-world impact.
                                </p>
                                
                                <p>
                                    Her leadership focuses on creating an inclusive ecosystem where trusted professionals, small businesses, and clients can connect seamlessly through modern technology. At WamGlammz, she champions a mission rooted in accessibility, quality, and empowerment—guided by the brand’s signature <span className="text-[#5B21B6] font-medium">royal purple</span> and <span className="text-[#D4AF37] font-medium">gold</span> identity. 
                                </p>

                                <p className="pt-2 border-t border-gray-100 italic text-gray-700 font-medium">
                                    "Her work continues to inspire individuals to discover their potential, express their authenticity, and step confidently into their purpose."
                                </p>
                            </div>

                            <div className="mt-8">
                                <a 
                                    href="http://www.linkedin.com/in/wamglammz" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 bg-[#5B21B6] hover:bg-[#4C1D95] text-white px-6 py-2.5 rounded-full text-sm font-bold transition shadow-md hover:shadow-lg"
                                >
                                    <i className="fa-brands fa-linkedin text-lg"></i>
                                    Connect on LinkedIn
                                </a>
                            </div>

                        </div>
                    </div>

                </div>
            </main>

            <Footer />
        </div>
    );
}